module.exports = "<div id=\"root\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/workflow-component/workflow-component.component.html
// module id = ../../../../../src/app/workflow-component/workflow-component.component.html
// module chunks = main